module.exports = __webpack_public_path__ + "static/media/jainy.3e311c60.png";